var alertTemplate = require('./../../shared/templates/dismissible-alert-template.handlebars');

$(function () {

    if (!$('.contactus-form-container').length) return;

    $('#modal-contactus-status').on('hide.bs.modal', function () {
        resetForm();
    });

    $('#btnSendEmail').on('click', function () {
        $(this).addClass('inProgress');

        let isValid = validateContactUsForm();

        if (isValid) {
            let formData = getContactUsFormData();
            sendContactUs(formData);
        }
    });
});

function sendContactUs(formData) {
    $.ajax({
        url: '/api/v1/forms',
        type: 'POST',
        data: formData,
        dataType: 'json'
    })
        .done(function (data) {
            if (data.isValid) {
                showContactUsConfirmationModal();
            } else {
                let alertData = {
                    message: data.message,
                    severity: { error: true }
                };
                let html = alertTemplate({ alertData: alertData });
                $('#contactus-form-validation-container').html(html);
            }

            $('#btnSendEmail').removeClass('inProgress');
        });
}

function getContactUsFormData() {
    let nameValue = $('#txt-yourname').val();
    let emailValue = $('#txt-youremail').val();
    let topicIdValue = $('#dd-topic').val();
    let messageValue = $('#txt-message').val();

    return {
        name: nameValue,
        emailAddress: emailValue,
        topicId: topicIdValue,
        message: messageValue
    };
}

function validateContactUsForm() {
    let $errorMessageContainer = $('#contactus-form-validation-container');
    $errorMessageContainer.empty();
    let errors = [];
    let $inputs = [
        $('#txt-yourname'),
        $('#txt-youremail'),
        $('#dd-topic'),
        $('#txt-message')
    ];


    $.each($inputs, function (i, v) {
        let $parent = v.parent('.form-group');
        if (!v[0].validity.valid) {
            let inputLabel = v.siblings('label')[0].innerText;
            errors.push({
                message: `'${inputLabel}' is invalid`,
                severity: { error: true }
            });
            $parent.addClass('has-error');
        } else {
            $parent.removeClass('has-error');
        }
    });

    errors.forEach(function (v, i, a) {
        displayValidationAlert(v, $errorMessageContainer)
    });

    if (!errors.length) {
        return true;
    } else {
        $('#btnSendEmail').removeClass('inProgress');
        return false;
    }
}

function displayValidationAlert(alert, $container) {
    let html = alertTemplate({ alertData: alert });
    $container.append(html);
}

function resetForm() {
    $('#txt-yourname').val("");
    $('#txt-youremail').val("");
    $('#dd-topic').val("");
    $('#txt-message').val("");
}

function showContactUsConfirmationModal() {
    $('#modal-contactus-status').modal('show');
}


// WEBPACK FOOTER //
// ./features/contactus/contactus.js